import styled from 'styled-components'

export const PreviewPageWrapper = styled.div`
    overflow: hidden;
`
